import React from 'react';
import {
  Dropdown,
  DropdownOverlay,
  SelectInput,
  ActionList,
  ActionListItem,
  Spinner,
  Box,
  Text,
  SelectInputProps,
  DropdownProps,
} from '@razorpay/blade/components';
import { statesOfIndia } from 'utils/StatesOfIndia';
import { useQuery } from 'react-query';
import api from 'api';

export const DistrictDropdown = ({
  value,
  selectedStateCode,
  onChange,
  _width = '50%',
}: {
  value: string;
  selectedStateCode: string;
  onChange: SelectInputProps['onChange'];
} & Partial<DropdownProps>) => {
  const selectedState =
    statesOfIndia.find((s) => s.code.toString() === selectedStateCode)?.esicState || '';


  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['districts', selectedState],
    queryFn: () => api.officeLocation.fetchDistricts({ state: selectedState }),
    enabled: !!selectedState,
  });

  return (
    <Dropdown selectionType="single" _width={_width}>
      <SelectInput
        name="district"
        label="District"
        necessityIndicator="required"
        isRequired
        placeholder="Choose District"
        value={value}
        onChange={onChange}
      />
      <DropdownOverlay>
        {isLoading || isFetching ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap="spacing.5"
            padding="spacing.5">
            <Spinner accessibilityLabel="loading states" />
          </Box>
        ) : data?.length ? (
          <ActionList>
            {data?.map((district) => (
              <ActionListItem
                key={district}
                title={district}
                value={district}
                isSelected={value === district}
              />
            ))}
          </ActionList>
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="spacing.5"
            padding="spacing.5">
            <Box display="flex" flexDirection="column" gap="spacing.3">
              <Text size="medium" weight="semibold" textAlign="center">
                No Districts Present
              </Text>
            </Box>
          </Box>
        )}
      </DropdownOverlay>
    </Dropdown>
  );
};
